<template>
  <div>
    <div class='reload'>
      <el-breadcrumb separator="/">
        <span class="leftLine"></span>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button icon="el-icon-arrow-left"
                 size="mini"
                 @click="$router.push('/khgl')">返回</el-button>
    </div>

    <div class="containerBox">
      <div class="container">
        <p class="header">客户详细信息
          <el-button @click="xg"
                     v-if="show(this.menuList1,'edit')"
                     v-show="$route.path=='/CustomerManagement/CustomerInformation'||$route.path==='/CustomerManagement/electricityInformation'"
                     type="primary">修改</el-button>
        </p>
        <div class="ax_default line"></div>
        <el-menu mode="horizontal"
                 :default-active="activeIndex"
                 v-if="$route.path!='/CustomerManagement/khzlxz'&&$route.path!='/CustomerManagement/khzlxg'&&$route.path!='/CustomerManagement/ydxxxg'&&$route.path!='/CustomerManagement/xzdjxx'&&$route.path!='/CustomerManagement/dyxxxg'"
                 :router="true">
          <el-menu-item v-for="(item,index) in menuList"
                        :key="index"
                        :index='item.path'>{{item.label}}</el-menu-item>
          <!-- <el-menu-item index="/CustomerManagement/CustomerInformation">客户资料</el-menu-item>
          <el-menu-item index="/CustomerManagement/electricityInformation">用电信息</el-menu-item>
          <el-menu-item index="/CustomerManagement/TariffInformation">电价信息</el-menu-item>
          <el-menu-item index="/CustomerManagement/VoltageInformation">电压信息</el-menu-item>
          <el-menu-item index="/CustomerManagement/ElectricityBill">电费账单</el-menu-item>
          < <el-menu-item index="/CustomerManagement/CustomerInformation">公众号账户</el-menu-item> -->
          <!-- <el-menu-item index="/CustomerManagement/hhxx">户号信息</el-menu-item> -->
        </el-menu>
        <el-menu mode="horizontal"
                 :default-active="activeIndex1"
                 v-if="$route.path=='/CustomerManagement/khzlxz'||$route.path=='/CustomerManagement/ydxxxg'||$route.path=='/CustomerManagement/xzdjxx'||$route.path=='/CustomerManagement/dyxxxg'"
                 :router="true">
          <el-menu-item index="/CustomerManagement/khzlxz">客户资料</el-menu-item>
          <el-menu-item index="/CustomerManagement/ydxxxg">用电信息</el-menu-item>
        <el-menu-item index="/CustomerManagement/xzdjxx">电价信息</el-menu-item>
          <el-menu-item index="/CustomerManagement/dyxxxg">电压信息</el-menu-item>
            <!-- <el-menu-item index="/CustomerManagement/ElectricityBill">电费账单</el-menu-item>
          < <el-menu-item index="/CustomerManagement/CustomerInformation">公众号账户</el-menu-item> -->
          <!-- <el-menu-item index="/CustomerManagement/hhxx">户号信息</el-menu-item> -->
        </el-menu>
        <el-main>
          <router-view :key="$route.path" />
        </el-main>
      </div>
    </div>
  </div>
</template>
<script>
import { getmenu, getmenusubmenu } from '../../API'
import { parantId } from '../../util/parantId'
import { show } from '../../util/show'
export default {
  data () {
    return {
      activeIndex: this.$route.path,
      activeIndex1:this.$route.path,
      selectMeun: '',
      name: this.$route.name,
      menuList: [],
      menuList1: []
    }
  },
  created () {
    if (this.$route.matched[2].path === '/CustomerManagement/khzlxg') {
      this.activeIndex = '/CustomerManagement/CustomerInformation'
    }
    else if (this.$route.matched[2].path === '/CustomerManagement/ydxxxg') {
      this.activeIndex = '/CustomerManagement/electricityInformation'
    }
    else if (this.$route.matched[2].path === '/CustomerManagement/xzdjxx') {
      this.activeIndex = '/CustomerManagement/TariffInformation'
    }
    else if (this.$route.matched[2].path === '/CustomerManagement/dyxxxg') {
      this.activeIndex = '/CustomerManagement/VoltageInformation'
    }
    if (this.$store.state.menuList.khgllist.length > 0) {
      this.menuList = this.$store.state.menuList.khgllist
    }
    else {
      getmenu({ parentId: localStorage.getItem('parentId'), lazy: true }).then(res => {
        if (res.code === 0) {
          this.menuList = res.data
          this.$store.commit('menuList/COMMIT_DATA', { name: 'khgllist', data: res.data })
        }
      })
    }
    parantId(this.$store.state.permissionList.data, this.$route.path, this.$store)
    if(this.$store.state.parantId.parantId){
     getmenusubmenu(this.$store.state.parantId.parantId).then(res => {
        if (res.code === 0) {
          this.menuList1 = res.data
        }
      })
    }

  },
  watch: {
    "$store.state.parantId.parantId" (newval, olval) {
      getmenusubmenu(newval).then(res => {
        if (res.code === 0) {
          this.menuList1 = res.data
  
        }
      })
    },
    '$route.path' (to, from) {
      this.name = this.$route.name
    }
  },
  methods: {
    show,
    routePush (key) {
      this.selectMeun = key
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath);
    },
    xg () {
      if (this.$route.path == '/CustomerManagement/CustomerInformation') {
        this.$router.push('/CustomerManagement/khzlxg')
      }
      else {
        this.$router.push('/CustomerManagement/ydxxxg')
      }
    }
  },
}
</script>
<style lang='less' scoped>
.containerBox {
  padding: 14px;
  background-color: rgba(249, 249, 249, 1);
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
/deep/ .el-breadcrumb__item {
  float: none;
  margin: 0;
}
.container {
  background-color: #fff;
}
.el-main {
  padding: 0;
}
.container {
  border: 1px solid rgb(228, 228, 228);
  border-top: 7px solid rgba(52, 152, 219, 1);
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
}
.reload {
  background-color: rgba(236, 240, 245, 1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
  height: 50px;
  line-height: 50px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#e4e4e4;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
</style>